var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("BaseToggleButton", {
        staticClass: "mb-1",
        attrs: {
          options: _vm.toggleOptions,
          small: "",
          "button-style": "flatGray"
        },
        model: {
          value: _vm.filterMode,
          callback: function($$v) {
            _vm.filterMode = $$v
          },
          expression: "filterMode"
        }
      }),
      _vm.isFamilyGroupMode
        ? _c(
            "FamilyGroupSearch",
            _vm._b(
              {
                ref: "familyGroupSearch",
                attrs: {
                  value: _vm.currentFamilyGroup,
                  grupos: _vm.grupos,
                  loading: _vm.loadingGroups
                },
                on: { select: _vm.selectFamilyGroup }
              },
              "FamilyGroupSearch",
              _vm.$attrs,
              false
            )
          )
        : _c(
            "v-autocomplete",
            _vm._g(
              _vm._b(
                {
                  ref: "campo",
                  staticClass: "p-0 new-ux-scroll client-search__field",
                  staticStyle: { "max-width": "180px" },
                  attrs: {
                    id: "client-search",
                    placeholder:
                      _vm.filterMode === "leads"
                        ? "Selecione um lead"
                        : "Selecione um cliente",
                    rounded: "",
                    items: _vm.clientesComEmail,
                    "item-value": "id",
                    "item-text": "name",
                    autocomplete: "off",
                    filter: _vm.customFilter
                  },
                  on: { change: _vm.search },
                  scopedSlots: _vm._u([
                    {
                      key: "item",
                      fn: function(data) {
                        return [
                          _c(
                            "v-list-item-content",
                            { staticStyle: { display: "table-column" } },
                            [
                              _c(
                                "v-row",
                                {
                                  staticStyle: {
                                    padding: "5px",
                                    "align-items": "center"
                                  }
                                },
                                [
                                  !data.item || !data.item.id_cadastro_cliente
                                    ? _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            small: "",
                                            right: "",
                                            color: "primary"
                                          }
                                        },
                                        [_vm._v(" mdi-account ")]
                                      )
                                    : _c(
                                        "v-icon",
                                        { attrs: { small: "", right: "" } },
                                        [_vm._v(" mdi-account-switch ")]
                                      ),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: {
                                        "margin-bottom": "0px",
                                        "margin-left": "5px"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            data.item ? data.item.name : ""
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("v-row", [
                                _c(
                                  "small",
                                  {
                                    staticClass: "text-secondary",
                                    staticStyle: { "margin-left": "15px" }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          data.item
                                            ? data.item.emailExibido
                                            : ""
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.searchClientTxt,
                    callback: function($$v) {
                      _vm.searchClientTxt = $$v
                    },
                    expression: "searchClientTxt"
                  }
                },
                "v-autocomplete",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            )
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }